export default __webpack_public_path__ + "static/media/seafood.68d92932.png";